import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import type { SortableColumn } from 'components/table';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon, CheckWhiteIcon } from 'assets/icons';
import moment from 'moment';
import { ChatService, GeneralService } from 'services';
import ViewChat from './view-chat';
import ModalAssignament from './modal-assignament';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  area_id: '',
  status: '',
  date: '',
  sort_by: '',
  sort_direction: '',
};

const SORTABLE_COLUMNS: SortableColumn[] = [
  { index: 7, key: 'internal', type: 'number' },
  { index: 8, key: 'type', type: 'number' },
  { index: 9, key: 'status', type: 'number' },
];

class AdminChat extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'Fecha',
      'ID',
      'Área',
      'Cliente/Abogado',
      'C.I.',
      'Abogado',
      'Inpre',
      'Gestión del caso',
      'Tipo',
      'Estatus',
      'Acciones',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    visible: false,
    item: null,
    visible_assign: false,
    areas: [],
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Chat',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadData();
    this.load();
  }

  loadData = async () => {
    const res: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      area: true,
      withoutLoading: true,
    });
    this.setState({
      areas: res.areas || [],
    });
  };

  load = async (withoutLoading: boolean = false) => {
    const res: any = await ChatService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.chats.rows,
      last_page: res.chats.count,
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  onServerSort = (key: string, direction: 'asc' | 'desc' | null) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          sort_by: direction ? key : '',
          sort_direction: direction ? direction.toUpperCase() : '',
        },
      },
      () => this.load(true),
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState(
      {
        visible: true,
        item,
      },
      () => {
        Globals.hideTooltip();
      },
    );
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  getUserByLevel = (i: any, level: number) => {
    if (i?.sender?.level_id === level) return i.sender;
    if (i?.receiver?.level_id === level) return i.receiver;
    return null;
  };

  getColor = (internal: number) => {
    switch (internal) {
      case Constants.LAWYER_INTERNAL.YES:
        return Colors.gray6;
        break;

      case Constants.LAWYER_INTERNAL.NO:
        return Colors.blueDark;
        break;
    }
  };

  getStatusColor = (status: number) => {
    switch (status) {
      case Constants.CHAT_RESOLVED_STATUS.PENDING:
        return Colors.gray6;
        break;

      case Constants.CHAT_RESOLVED_STATUS.RESOLVED:
        return Colors.blueDark;
        break;

      case Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED:
        return Colors.danger;
        break;

      case Constants.CHAT_RESOLVED_STATUS.REVIEW:
        return Colors.yellow;
        break;

      case Constants.CHAT_RESOLVED_STATUS.IN_PROCESS:
        return Colors.cyan2;
        break;
    }
  };

  onOpenAssign = (item: any) => {
    this.setState({
      visible_assign: true,
      item,
    });
  };
  onCloseAssign = (load: boolean = false) => {
    this.setState(
      {
        visible_assign: false,
        item: null,
      },
      () => load && this.load(true),
    );
  };

  payment = (item: any) => {
    Globals.confirm('¿Marcar el chat como pagado?', async () => {
      await ChatService.admin.payment({
        chat_id: item?.id,
      });
      this.load(true);
    });
  };

  render() {
    const { visible, visible_assign } = this.state;

    return (
      <div id='admin-chat'>
        <Modal
          className='modal-assign-lawyer'
          visible={visible_assign}
          title=''
          hideHeader={true}
          onClose={() => this.onCloseAssign()}
        >
          {/* @ts-ignore */}
          <ModalAssignament item={this.state.item} onClose={() => this.onCloseAssign()} />
        </Modal>
        <div className={`container-modal-right ${visible ? 'active' : ''}`}>
          {visible && <ViewChat item={this.state.item} onClose={() => this.onClose()} />}
        </div>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Área'
                  name='area_id'
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.area_id}
                  options={this.state.areas.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-3'>
                <DatePicker
                  label='Fecha'
                  placeholder='Fecha'
                  maxDate={moment().toDate()}
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'date',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.date}
                />
              </div>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Estatus de consulta'
                  name='status'
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.status}
                  options={[
                    {
                      value: Constants.CHAT_RESOLVED_STATUS.PENDING.toString(),
                      label: 'Pendiente',
                    },
                    {
                      value: Constants.CHAT_RESOLVED_STATUS.IN_PROCESS.toString(),
                      label: 'En proceso',
                    },
                    {
                      value: Constants.CHAT_RESOLVED_STATUS.REVIEW.toString(),
                      label: 'En revisión',
                    },
                    {
                      value: Constants.CHAT_RESOLVED_STATUS.RESOLVED.toString(),
                      label: 'Resuelto',
                    },
                    {
                      value: Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED.toString(),
                      label: 'No resuelto',
                    },
                  ]}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Chat'
          data={this.state.data.length}
          header={this.state.header}
          sortableColumns={SORTABLE_COLUMNS}
          serverSort={true}
          onServerSort={this.onServerSort}
          rightAlign={[10]}
        >
          {this.state.data.map((i: any, index: number) => {
            const user = i?.sender;
            const lawyer = i?.receiver;
            return (
              <tr key={index}>
                <td>
                  {moment(i.created_at).isValid() ? moment(i.created_at).format('DD/MM/YYYY') : ''}
                </td>
                <td>{i.number_format}</td>
                <td>{i?.area?.name || '-'}</td>
                <td>{user?.full_name || ''}</td>
                <td>{user?.full_document || ''}</td>
                <td>{lawyer?.full_name || ''}</td>
                <td>{lawyer?.lawyer_document || ''}</td>
                <td>
                  {lawyer != null ? (
                    <p className='internal' style={{ color: this.getColor(lawyer?.internal) }}>
                      {lawyer?.internal == Constants.LAWYER_INTERNAL.YES ? 'Interna' : 'Externa'}
                    </p>
                  ) : (
                    ''
                  )}
                </td>
                <td>
                  {i.type === Constants.CHAT_TYPE.CLIENT_LAWYER_WITH_FILES
                    ? 'Directorio'
                    : 'Consulta interna'}
                </td>
                <td
                  className='status'
                  style={{
                    color:
                      i.type !== Constants.CHAT_TYPE.CLIENT_LAWYER_WITH_FILES
                        ? this.getStatusColor(i?.chatResolved?.status)
                        : undefined,
                  }}
                >
                  {i.type !== Constants.CHAT_TYPE.CLIENT_LAWYER_WITH_FILES
                    ? i?.chatResolved?.status_text
                    : ''}
                </td>
                <td className='text-right'>
                  {this.props.user?.level_id === Constants.LEVELS.MODERATOR && (
                    <Tooltip title='Ver'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {lawyer?.internal == Constants.LAWYER_INTERNAL.NO &&
                    i?.chatResolved?.status ==
                      Constants.CHAT_RESOLVED_STATUS.RESOLVED.toString() && (
                      <button
                        className={`btn btn-payment ${i.status_payment ? 'active' : ''}`}
                        disabled={i.status_payment}
                        onClick={() => this.payment(i)}
                      >
                        {!i.status_payment && <img src={CheckWhiteIcon} />}
                        {i.status_payment ? 'Pagado' : 'Pagar'}
                      </button>
                    )}
                  {i.type === Constants.CHAT_TYPE.CLIENT_LAWYER &&
                    (i.chatResolved?.status == Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED ||
                      i.chatResolved?.status == Constants.CHAT_RESOLVED_STATUS.PENDING) && (
                      <span className='assign-lawyer' onClick={(e: any) => this.onOpenAssign(i)}>
                        Asignar
                      </span>
                    )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminChat);
